/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface CalendarAppointmentVideoCallLinkResponse { 
    videoCallUrl: string;
}
export const CalendarAppointmentVideoCallLinkResponse_videoCallUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];


